module.exports = __webpack_public_path__ + "img/user-4.c29c0920.jpg";